import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useRef, useState } from 'react';
import { isFunction } from '../utils';
export default function useRefState(initialState) {
  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var ref = useRef(state);
  var setRafState = useCallback(function (patch) {
    setState(function (prevState) {
      // eslint-disable-next-line no-return-assign
      return ref.current = isFunction(patch) ? patch(prevState) : patch;
    });
  }, [state]);
  return [state, setRafState, ref];
}